import React, { useContext } from 'react';
import { ILocationResponseItem } from './models/ILocationResponseItem';
import { ICategoryResponseItem } from './models/ICategoryResponseItem';
import { IPlacemarkResponseItem } from './models/IPlacemarkResponseItem';

export interface IPlacemarksData {
	placemarks: IPlacemarkResponseItem[];
	placemarksError: Error | null;
	placemarksLoading: boolean;
	locations: ILocationResponseItem[];
	locationsError: Error | null;
	locationsLoading: boolean;
	categories: ICategoryResponseItem[];
	categoriesError: Error | null;
	categoriesLoading: boolean;
}
export const PlacemarksDataContext = React.createContext<IPlacemarksData>(
	{} as IPlacemarksData,
);
export const PlacemarksDataProvider = PlacemarksDataContext.Provider;
export const useMeridianData = () => useContext(PlacemarksDataContext);
